import styled from "styled-components";
import {CellBox} from "./cell.box";
import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../../hooks/use-services.hook";

const HeaderCellBox = styled(CellBox)`
    position: sticky;
    top: 0;
    font-weight: ${props => props.theme.fontWeight.semiBold};
    background-color: ${props => props.theme.colors.lightShade};
    border-color: ${props => props.theme.colors.light};
`

const HeaderCellCenteredBox = styled(HeaderCellBox)`
    justify-content: center;
`

export const TableHeaderComponent: React.FC = observer(() => {
    const services = useServices();
    return (
        <>
            <HeaderCellBox></HeaderCellBox>
            <HeaderCellCenteredBox>{services.language.translate('No.')}</HeaderCellCenteredBox>
            <HeaderCellCenteredBox>PNR</HeaderCellCenteredBox>
            <HeaderCellBox>{services.language.translate('Origin')}</HeaderCellBox>
            <HeaderCellBox>{services.language.translate('Destination')}</HeaderCellBox>
            <HeaderCellCenteredBox>{services.language.translate('Flight number')}</HeaderCellCenteredBox>
            <HeaderCellCenteredBox>{services.language.translate('Flight date')}</HeaderCellCenteredBox>
            <HeaderCellBox>{services.language.translate('Passenger')}</HeaderCellBox>
            <HeaderCellCenteredBox>{services.language.translate('Status')}</HeaderCellCenteredBox>
            <HeaderCellBox>{services.language.translate('Agent')}</HeaderCellBox>
        </>
    )
})